import { css, etiColors, mediaQueries } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const seatWrapperStyles = isOpen => css`
  display: flex;
  flex-direction: row;

  ${isOpen ? css`
        align-items: flex-start;
        padding: 0 13px 13px 0;
        width: 100%;

        [dir='rtl'] & {
          padding: 0 0 13px 13px;
        }
      ` : css`
        align-items: center;
        padding: 0 16px 13px 0;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
          padding-right: 45px;
          [dir='rtl'] & {
            margin-left: 0;
            padding-left: 45px;
            padding-right: 0;
          }
        }
      `};

  @media ${mediaQueries.medium.up} {
    border-bottom: 0;
    min-width: 25%;

    ${isOpen ? css`
          margin: 0;
          padding-bottom: 13px;
          padding-right: 13px;
          width: 25%;

          [dir='rtl'] & {
            padding-left: 13px;
            padding-right: 0;
          }

          /* stylelint-disable no-descending-specificity */
          &:nth-child(odd) {
            padding-right: 10px;
            [dir='rtl'] & {
              padding-left: 10px;
              padding-right: 0;
            }
          }
          /* stylelint-enable no-descending-specificity */
        ` : css`
          flex-basis: 120px;
          padding-right: 0;
        `};
  }
`;
export const SeatWrapper = _ref => {
  let {
    isOpen,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: seatWrapperStyles(isOpen),
    ...rest
  });
};
const textContentStyles = isOpen => css`
  display: flex;
  flex-direction: column;

  h3 {
    color: ${etiColors.black};
    font-size: ${isOpen ? '0.75rem' : '0.563rem'};
    font-weight: 600;
    font-weight: 700;
    margin-bottom: ${isOpen ? '0.25rem' : 0};
    ${!isOpen && 'white-space: nowrap'};
  }

  span {
    color: ${etiColors.grayScale[10]};
    display: ${isOpen ? 'block' : 'none'};
    font-size: ${isOpen ? '0.75rem' : '0.563rem'};
    line-height: 1.2;
    margin-bottom: ${isOpen ? '0.188rem' : 0};
    ${!isOpen && 'white-space: nowrap'};
  }

  p {
    color: ${etiColors.grayScale[10]};
    font-size: ${isOpen ? '0.75rem' : '0.563rem'};
  }

  @media ${mediaQueries.medium.up} {
    h3 {
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1;
      margin-bottom: 0.25rem;
    }
    span {
      display: block;
      font-size: 0.75rem;
      line-height: 1.2;
      margin-bottom: ${isOpen ? '0.188rem' : 0};
    }
    p {
      font-size: ${isOpen ? '0.75rem' : '0.563rem'};
    }
  }
`;
export const TextContent = _ref2 => {
  let {
    isOpen,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: textContentStyles(isOpen),
    ...rest
  });
};
const iconWrapperStyles = (isOpen, size) => css`
  margin-bottom: auto;
  margin-left: 0;
  margin-right: ${isOpen ? '' : '0.563rem'};
  min-width: ${`${size}rem`};
  width: ${`${size}rem`};

  [dir='rtl'] & {
    margin-left: ${isOpen ? '' : '0.563rem'};
    margin-right: 0;
  }

  svg {
    display: block;
  }
`;
export const IconWrapper = _ref3 => {
  let {
    isOpen,
    size,
    ...rest
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: iconWrapperStyles(isOpen, size),
    ...rest
  });
};
export const iconClassName = isOpen => css`
  transform: ${isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;
const legendBarStyles = isOpen => css`
  background-color: ${etiColors.white};
  bottom: 0;
  display: block;
  left: 0;
  max-height: ${isOpen && `600px`};
  overflow-y: ${isOpen && `auto`};
  position: absolute;
  right: 0;
  transition: 0.4s;
  width: 100%;
  z-index: 5;

  @media ${mediaQueries.small.only} {
    max-height: ${isOpen && `300px`};
  }
`;
export const LegendBar = _ref4 => {
  let {
    innerRef,
    isOpen,
    ...rest
  } = _ref4;
  return /*#__PURE__*/_jsx("div", {
    className: legendBarStyles(isOpen),
    ref: innerRef,
    ...rest
  });
};
const toggleWrapperStyles = css`
  background: #fff;
  background: linear-gradient(
    to right,
    rgb(255 255 255 / 0%) 0%,
    rgb(255 255 255 / 100%) 50%,
    rgb(255 255 255 / 100%) 100%
  );
  cursor: pointer;
  padding: 12px 10px 10px 12px;
  position: absolute;
  right: 0;

  [dir='rtl'] & {
    background: linear-gradient(
      to left,
      rgb(255 255 255 / 0%) 0%,
      rgb(255 255 255 / 100%) 50%,
      rgb(255 255 255 / 100%) 100%
    );
    left: 0;
    padding: 12px 30px 12px 10px;
    right: unset;
  }
`;
export const ToggleWrapper = props => /*#__PURE__*/_jsx("span", {
  className: toggleWrapperStyles,
  ...props
});
const legendWrapperStyles = css`
  display: flex;
  height: 100%;
  margin: 0 auto;
  max-width: 848px;
  position: relative;
  width: 100%;
`;
export const LegendWrapper = _ref5 => {
  let {
    innerRef,
    ...rest
  } = _ref5;
  return /*#__PURE__*/_jsx("div", {
    className: legendWrapperStyles,
    ref: innerRef,
    ...rest
  });
};
const childWrapperStyles = isOpen => css`
  align-content: start;
  align-items: flex-start;
  display: flex;
  flex-flow: row ${isOpen && `wrap`};
  margin-top: 14px;
  overflow: auto;
  padding: 0 14px;

  [dir='rtl'] & {
    padding: 0 14px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${mediaQueries.medium.up} {
    padding: 0 40px 0 16px;
    width: 100%;
    [dir='rtl'] & {
      padding: 0 16px 0 40px;
    }
  }
`;
export const ChildWrapper = _ref6 => {
  let {
    isOpen,
    ...rest
  } = _ref6;
  return /*#__PURE__*/_jsx("div", {
    className: childWrapperStyles(isOpen),
    ...rest
  });
};
//# sourceMappingURL=StyledComponents.js.map